(function() {
  var VARIANT_ID = '01a19859-6085-7e01-9797-e278454b1155';
  var BUILDER_URL = '/pages/coffee-club-builder';
  var SUBSCRIBE_URL = BUILDER_URL;
  var ASSIGNMENT_TIMEOUT_MS = 3000;

  function getAssignment() {
    return new Promise(function(resolve) {
      var startedAt = Date.now();

      function checkShoplift() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          window.shoplift.isHypothesisActive(VARIANT_ID).then(resolve).catch(function() {
            resolve(false);
          });
          return;
        }

        if (Date.now() - startedAt >= ASSIGNMENT_TIMEOUT_MS) {
          resolve(false);
          return;
        }

        window.setTimeout(checkShoplift, 50);
      }

      checkShoplift();
    });
  }

  function getTopLevelItem(menuSelector, label) {
    return Array.prototype.find.call(document.querySelectorAll(menuSelector), function(item) {
      var trigger = item.querySelector(':scope > a, :scope > button, :scope > .mobile-nav__has-sublist > a, :scope > .mobile-nav__has-sublist > button');
      return trigger && trigger.textContent.trim().toLowerCase() === label;
    });
  }

  function addDesktopSubscribeLink() {
    var coffeeItem = getTopLevelItem('#SiteHeader .site-nav > .site-nav__item', 'coffee');
    if (!coffeeItem || coffeeItem.querySelector('[data-bocc-coffee-subscribe-link]')) {
      return;
    }

    var dropdownList = coffeeItem.querySelector(':scope > ul.site-nav__dropdown');
    if (dropdownList) {
      var listItem = document.createElement('li');
      listItem.setAttribute('data-bocc-coffee-subscribe-link', '');
      listItem.innerHTML = '<a href="' + SUBSCRIBE_URL + '" class="site-nav__dropdown-link site-nav__dropdown-link--second-level">Subscribe &amp; Save</a>';
      dropdownList.prepend(listItem);
      return;
    }

    var firstColumn = coffeeItem.querySelector(':scope > .megamenu .grid__item');
    if (firstColumn) {
      var heading = document.createElement('div');
      heading.className = 'h5';
      heading.setAttribute('data-bocc-coffee-subscribe-link', '');
      heading.innerHTML = '<a href="' + SUBSCRIBE_URL + '" class="site-nav__dropdown-link site-nav__dropdown-link--top-level">Subscribe &amp; Save</a>';
      firstColumn.prepend(heading);
    }
  }

  function addMobileSubscribeLink() {
    var coffeeItem = getTopLevelItem('#NavDrawer .mobile-nav > .mobile-nav__item', 'coffee');
    if (!coffeeItem || coffeeItem.querySelector('[data-bocc-coffee-subscribe-link]')) {
      return;
    }

    var submenu = coffeeItem.querySelector(':scope > .mobile-nav__sublist .collapsible-content__inner > ul.mobile-nav__sublist');
    if (!submenu) {
      return;
    }

    var listItem = document.createElement('li');
    listItem.className = 'mobile-nav__item';
    listItem.setAttribute('data-bocc-coffee-subscribe-link', '');
    listItem.innerHTML = '<div class="mobile-nav__child-item"><a href="' + SUBSCRIBE_URL + '" class="mobile-nav__link">Subscribe &amp; Save</a></div>';
    submenu.prepend(listItem);
  }

  function updateVariantLinks() {
    document.querySelectorAll('#SiteHeader a, #NavDrawer a').forEach(function(link) {
      if (link.textContent.trim().toLowerCase() === 'coffee club') {
        link.href = BUILDER_URL;
      }
    });

    document.querySelectorAll('.bocc-seo-hero__btn--secondary').forEach(function(link) {
      var arrow = link.querySelector('[aria-hidden="true"]');

      link.textContent = 'Subscribe & Save ';
      if (arrow) {
        link.appendChild(arrow);
      }
      link.href = BUILDER_URL;
    });

    document.querySelectorAll('.bocc-seo-hero__cta-microcopy-link').forEach(function(link) {
      link.href = BUILDER_URL;
    });
  }

  function applyVariant() {
    addDesktopSubscribeLink();
    addMobileSubscribeLink();
    updateVariantLinks();
  }

  var ready = getAssignment().then(function(isVariant) {
    if (isVariant) {
      applyVariant();
    }

    return isVariant;
  });

  window.bocc23MegaMenuExperiment = {
    applyVariant: applyVariant,
    ready: ready
  };
})();
